import Chip from "@mui/material/Chip";
import { colors, radius } from "../../data/tokens";

// Tipos de contato (valores do formulário) → rótulo exibido e cores do chip
export const FEEDBACK_TYPES: Record<
  string,
  { label: string; bg: string; fg: string }
> = {
  other: { label: "Outro", bg: colors.neutral100, fg: colors.textMuted },
  contact: { label: "Contato", bg: colors.bgContent, fg: colors.primaryDark },
  request: {
    label: "Solicitação de Alteração",
    bg: colors.bgContent,
    fg: colors.primaryDark,
  },
  feature: {
    label: "Solicitar Recurso",
    bg: colors.bgContent,
    fg: colors.primaryDark,
  },
  bug: { label: "Reportar Bug", bg: colors.actionSoft, fg: colors.action },
  debit: { label: "Débito", bg: colors.actionSoft, fg: colors.action },
};

// Busca do sócio na tela Sócios pelo e-mail/CPF do contato — mesmo
// filtro (mailName) que o botão antigo da listagem usava.
export function memberSearchHref(email: string): string {
  return (
    "/#/users/crud/?filter=%7B%22mailName%22%3A%22" +
    encodeURIComponent(email) +
    "%22%7D"
  );
}

export function FeedbackTypeChip({ type }: { type?: string }) {
  const chip = (type && FEEDBACK_TYPES[type]) || {
    label: type || "—",
    bg: colors.neutral100,
    fg: colors.textMuted,
  };
  return (
    <Chip
      label={chip.label}
      size="small"
      sx={{
        backgroundColor: chip.bg,
        color: chip.fg,
        fontWeight: 600,
        fontSize: 12,
        height: 22,
        borderRadius: `${radius.sm}px`,
      }}
    />
  );
}
